import React, {Component} from 'react';
import {controlMaxWidthStyle, errorMessageStyle} from '../styles';
import AuthenticationService from './authentication-service';

export default class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            rememberMe: false,
            isLoggingIn: false,
            errorMessage: ''
        };
        this.authenticationService = AuthenticationService;
    }

    inputChanged = e => {
        const state = this.state;
        state[e.target.id] = e.target.value;
        this.setState(state);
    };

    toggleRememberMe = () => {
        const newState = !this.state.rememberMe;
        this.setState({rememberMe: newState});
    };

    logIn = () => {
        this.setState({isLoggingIn: true, errorMessage: ''});
        this.authenticationService.logIn(this.state.email, this.state.password, this.state.rememberMe, this.props.isAdminOnly)
            .done(requiresPasswordReset => this.props.onLogIn(requiresPasswordReset === 'true'))
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isLoggingIn: false}));
    };

    render() {
        return (
            <div>
                <form className="form-horizontal" style={{marginTop: '20px'}}>
                    <div className="form-group">
                        <label htmlFor="email" className="col-sm-2 control-label">Email</label>
                        <div className="col-sm-10">
                            <input type="email"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="email"
                                   placeholder="Email"
                                   value={this.state.email}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="password" className="col-sm-2 control-label">Password</label>
                        <div className="col-sm-10">
                            <input type="password"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="password"
                                   placeholder="Password"
                                   value={this.state.password}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <div className="checkbox">
                                <label>
                                    <input id="rememberMe"
                                           type="checkbox"
                                           checked={this.state.rememberMe}
                                           onChange={this.toggleRememberMe}/> Remember Me
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            {this.state.isLoggingIn ?
                                <button type="button" className="btn btn-default" disabled>Signing in...</button> :
                                <button type="submit" className="btn btn-default" onClick={this.logIn}>Sign in</button>}
                        </div>
                    </div>
                    {this.state.errorMessage ?
                        <div className="col-sm-offset-2 col-sm-10" style={{padding: '4px'}}>
                            <div className="alert alert-danger" style={errorMessageStyle}>{this.state.errorMessage}</div>
                        </div>
                        : undefined}
                </form>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/auth/login-form.js